import React from 'react';
import { Navigate } from 'react-router-dom';
import useAppStore from '../../store';
import ForbiddenPage from '../../features/placeholder/ForbiddenPage';

/**
 * Role gate (T8.9). Wrong-role access renders the 403 page — never a silent
 * redirect that could mask a permissions bug. Client-role users get bounced
 * away from agency routes to their portal home (T8.10) with `blockedFrom`
 * context; agency roles hitting client routes land on /approvals.
 *
 * Client-side checks are UX only — the backend must re-check (spec §4.4).
 */
function RequireRole({ roles, children }) {
  const role = useAppStore((state) => state.session?.role);

  if (roles.includes(role)) {
    return children;
  }

  if (role === 'client') {
    return <Navigate replace state={{ blockedFrom: 'agency' }} to="/client/home" />;
  }

  return <ForbiddenPage attemptedRole={role} />;
}

export default RequireRole;
